import { call, takeEvery, put } from 'redux-saga/effects';

import {
  FETCH_ANALYTICS,
  FETCH_EXPORT_ANALYTICS,
  receiveAnalytics,
  setAnalyticsLoading,
} from './actions';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import { getSwitchgearCounterAggregates } from '../../services';

const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

export function* doFetchAnalytics(action) {
  const { query, panelId } = action;
  try {
    yield put(setAnalyticsLoading(true, panelId));

    if (!query.sourceId) {
      console.warn('No sourceId provided for analytics fetch');
      yield put(receiveAnalytics([], query, 0, panelId));
      return;
    }

    const apiQuery = {
      time_from: new Date(query.from).toISOString(),
      time_to: new Date(query.to).toISOString(),
      entity_id: query.entityId,
    };
    const response = yield call(getSwitchgearCounterAggregates, query.sourceId, apiQuery);
    const data = (response.items || []).map((item) => {
      let days = 0;
      if (item.last_operation_time) {
        days = Math.floor((Date.now() - new Date(item.last_operation_time)) / MILLISECONDS_PER_DAY);
        if (days < 0) days = 0;
      }
      return {
        ...item,
        status: item.current_status === 0 ? 'ok' : 'unknown',
        days_since_last_operation: days,
      };
    });
    const total = response.total ?? data.length;

    yield put(receiveAnalytics(data, query, total, panelId));
  } catch (error) {
    console.error('Unable to fetch analytics data:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getAnalytics', 'error')()));
  } finally {
    yield put(setAnalyticsLoading(false, panelId));
  }
}

export function* doFetchExportAnalytics(action) {
  const { query, exportCallback, panelId } = action;
  try {
    yield put(setAnalyticsLoading(true, panelId));

    if (!query.sourceId) {
      console.warn('No sourceId provided for analytics export');
      if (exportCallback) exportCallback([]);
      return;
    }

    // Map frontend query params to backend API params
    const apiQuery = {
      time_from: new Date(query.from).toISOString(),
      time_to: new Date(query.to).toISOString(),
      entity_id: query.entityId,
    };

    const response = yield call(getSwitchgearCounterAggregates, query.sourceId, apiQuery);
    const data = (response.items || []).map((item) => {
      let days = 0;
      if (item.last_operation_time) {
        days = Math.floor((Date.now() - new Date(item.last_operation_time)) / MILLISECONDS_PER_DAY);
        if (days < 0) days = 0;
      }
      return {
        ...item,
        status: item.current_status === 0 ? 'ok' : 'unknown',
        days_since_last_operation: days,
      };
    });

    if (exportCallback) {
      exportCallback(data);
    }
  } catch (error) {
    console.error('Unable to fetch analytics export data:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getAnalytics', 'error')()));
  } finally {
    yield put(setAnalyticsLoading(false, panelId));
  }
}

export const sagas = [
  takeEvery(FETCH_ANALYTICS, doFetchAnalytics),
  takeEvery(FETCH_EXPORT_ANALYTICS, doFetchExportAnalytics),
];
